<template>
  <div>
    <ts-card>
      <div class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative">
        <h4 class="ts-text-sm">{{ $t('calculatePayroll.calculatePayroll') }}</h4>
        <ts-modal-close-button />
      </div>
    </ts-card>
    <ts-card-wrapper>
      <ts-loading-banner :loading="loadingPreData">
        <form>
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group m-b-10">
                <div>
                  <ts-radio
                    v-model.number="model.id_type"
                    value="1"
                    class="radio-inline"
                    :class="{ 'is-invalid': errors.has('id_type') }"
                  >{{ $t('calculatePayroll.orgChartStructure') }}</ts-radio>
                  <ts-radio
                    v-model.number="model.id_type"
                    value="3"
                    class="radio-inline"
                    :class="{ 'is-invalid': errors.has('id_type') }"
                  >{{ $t('calculatePayroll.shift') }}</ts-radio>
                  <ts-radio
                    v-model.number="model.id_type"
                    value="2"
                    class="radio-inline"
                    :class="{ 'is-invalid': errors.has('id_type') }"
                  >{{ $t('calculatePayroll.employee') }}</ts-radio>
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('id_type')"
                  >{{ errors.first('id_type') }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-if="model.id_type == 1">
            <div class="col-sm-12">
              <div class="form-group m-b-10">
                <label
                  class="col-form-label control-label required"
                >{{ $t('calculatePayroll.orgChartStructure') }}</label>
                <div>
                  <ts-search-select
                    v-model="model.org_chart_structure_id"
                    :options="
                      orgChartStructures.map(e => ({
                        text: e.org_chart_structure,
                        value: e.org_chart_structure_id
                      }))
                    "
                    :class="{ 'is-invalid': errors.has('org_chart_structure_id') }"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('org_chart_structure_id')"
                  >{{ errors.first('org_chart_structure_id') }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-if="model.id_type == 3">
            <div class="col-sm-12">
              <div class="form-group m-b-10">
                <label
                  class="col-form-label control-label required"
                >{{ $t('calculatePayroll.shiftName') }}</label>
                <div>
                  <treeselect
                    :multiple="true"
                    :limit="2"
                    v-model="model.shift_id"
                    :options="
                      shifts.map(e => ({
                        id: e.shift_id,
                        label: e.shift_name + ' (' + e.shift_type + ')'
                      }))
                    "
                    placeholder="Type for search..."
                    :class="{ 'is-invalid': errors.has('shift_id') }"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('shift_id')"
                  >{{ errors.first('shift_id') }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-if="model.id_type == 2">
            <div class="col-sm-12">
              <div class="form-group m-b-10">
                <label
                  class="col-form-label control-label required"
                >{{ $t('calculatePayroll.employee') }}</label>
                <div>
                  <treeselect
                    :multiple="true"
                    :limit="3"
                    :options="employees.map(i => ({
                        id: i.employee_id,
                        label: i.employee_name_en
                      }))"
                    placeholder="Type for search..."
                    v-model="model.employee_id"
                  ></treeselect>
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('employee_id')"
                  >{{ errors.first('employee_id') }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group m-b-10">
                <label
                  class="col-form-label control-label required"
                >{{ $t('calculatePayroll.cycleYear') }}</label>
                <div>
                  <ts-date-picker-input
                    :class="{ 'is-invalid': errors.has('cycle_year') }"
                    format="YYYY"
                    v-model="model.cycle_year"
                  ></ts-date-picker-input>
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('cycle_year')"
                  >{{ errors.first('cycle_year') }}</div>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <label
                class="col-form-label control-label required"
              >{{ $t('calculatePayroll.cycleMonth') }}</label>
              <div class="form-group m-b-10">
                <div>
                  <ts-date-picker-input
                    :class="{ 'is-invalid': errors.has('cycle_month') }"
                    format="MM"
                    v-model="model.cycle_month"
                  ></ts-date-picker-input>
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('cycle_month')"
                  >{{ errors.first('cycle_month') }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group m-b-10">
                <label
                  class="col-form-label control-label required"
                >{{ $t('calculatePayroll.cycleOrder') }}</label>
                <div>
                  <ts-select
                    v-model="model.cycle_order"
                    :options="
                      cycleOrders.map(e => ({
                        text: e.text,
                        value: e.value
                      }))
                    "
                    :class="{ 'is-invalid': errors.has('cycle_order') }"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('cycle_order')"
                  >{{ errors.first('cycle_order') }}</div>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group m-b-10" v-show="model.cycle_order != 1">
                <label
                  class="col-form-label control-label required"
                >{{ $t('calculatePayroll.exchangeRate') }}</label>
                <div>
                  <input
                    type="number"
                    v-model.number="model.exchange_rate"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has('exchange_rate') }"
                  />
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('exchange_rate')"
                  >{{ errors.first('exchange_rate') }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row ts-mt-6">
            <div class="col-md-12 text-right">
              <ts-button @click.prevent="$emit('close')">{{ $t('button.cancel') }}</ts-button>
              <ts-button
                @click.prevent="generate"
                class="btn-primary ml-2"
                :waiting="saving"
              >{{ $t('button.generate') }}</ts-button>
            </div>
          </div>
        </form>
      </ts-loading-banner>
    </ts-card-wrapper>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import moment from 'moment'

export default {
  props: ['editData'],
  name: 'calculate-payroll-form',
  data() {
    return {
      model: {
        org_chart_structure_id: '',
        shift_id: [],
        cycle_year: moment().format('YYYY'),
        cycle_month: moment().format('MM'),
        cycle_order: '',
        exchange_rate: '',
        id_type: 1,
        employee_id: []
      },
      errors: new Errors(),
      saving: false,
      loadingPreData: false
    }
  },
  created() {
    this.loadingPreData = true
    Promise.all([this.fetchEmployees(), this.fetchShift()]).then(() => {
      this.loadingPreData = false
    })
    this.fetchResourceBeforeCreate()
  },
  computed: {
    ...mapState('hr/calculatePayroll', ['orgChartStructures', 'cycleOrders', 'employees', 'shifts'])
  },
  methods: {
    ...mapActions('hr/calculatePayroll', ['fetchEmployees', 'fetchShift']),
    fetchResourceBeforeCreate() {
      this.$store
        .dispatch('hr/calculatePayroll/dataBeforeCreate')
        .then(() => {
          this.loadingPreData = false
        })
        .catch(error => {
          this.loadingPreData = false
          this.$toasted.error(error.message)
        })
    },
    generate() {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('hr/calculatePayroll/store', this.model)
        .then(response => {
          return this.$store
            .dispatch('hr/calculatePayroll/fetch', { cycle_year: this.cycle_year, cycle_month: this.cycle_month })
            .then(res => {
              this.saving = false
              this.$emit('before-close')
              this.$toasted.success(response.message)
              return Promise.resolve(res)
            })
        })
        .catch(error => {
          this.saving = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    }
  },
  watch: {
    'model.id_type': function(value) {
      if (value == 1) {
        this.model.employee_id = []
        this.model.shift_id = []
      } else if (value == 2) {
        this.model.org_chart_structure_id = ''
        this.model.shift_id = []
      } else {
        this.model.org_chart_structure_id = ''
        this.model.employee_id = []
      }
    }
  }
}
</script>
